var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex",style:(("font-size: " + _vm.size + ";"))},_vm._l((_vm.base),function(item,index){return _c('i',{key:index,class:{
            empty: !_vm.rating,
            negative: _vm.rating && _vm.rating <= 2,
            positive: _vm.rating > 2,
            active: Math.ceil(_vm.rating) >= item,
            fas: !_vm.rating,
            fas: (!!_vm.rating && !(_vm.showHalf && !Number.isInteger(_vm.rating) && parseInt(_vm.rating) == index)) || !_vm.rating,
            fad: _vm.showHalf && !Number.isInteger(_vm.rating) && parseInt(_vm.rating) == index,
            'fa-star': true,
            'fa-star-half': _vm.showHalf && !Number.isInteger(_vm.rating) && parseInt(_vm.rating) == index
        },style:(("color: " + _vm.color + ";"))})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }